import type { getWidgetLocation } from 'utils';

export enum HideNavParam {
  False = '0',
  True = '1',
}

type WidgetLocation = ReturnType<typeof getWidgetLocation>;
type WidgetLocationKey = keyof WidgetLocation;

export const FORCED_SHOW_HEADER_PATHS: WidgetLocationKey[] = [
  // 'isWithdrawalCardList',
  // 'isWithdrawalVerifyAccount',
  // 'isBetshopDeposit',
  // 'isBetshopWithdrawal',
  'isCards',
  // 'isSelectCountry',
];
